export default __webpack_public_path__ + "static/media/QiddiyaAboutImage.bb8d044f.jpeg";